<template>
  <div class="fd_body" v-if="body_show">
    <div class="men_informain" style="margin-top: 0;padding-top: 0;">
      <div class="men_pj" v-for="item in feedback">
        <div class="informain_top clearfix">
          <img :src="item.headimgurl" />
          <div class="infor_r">
            <h3>{{item.name}}<span>辅导满意度：{{item.satisfaction}}分</span><i></i><span>问题解决度：{{item.solve}}分</span></h3>
            <h4>{{item.ctime}}</h4>
          </div>
        </div>
        <p class="pj_p">{{item.remark}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  feebacklist
} from "@/api/totoring"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        feedback: {},
      }
    },
    methods: {
      pullData() {
        this.teacherid = this.$route.query.teacherid
        feebacklist({
            teacherid: this.$route.query.teacherid
          })
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.feedback = data.feedback;
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.fd_body {
  padding-bottom: changeRem(1.96)+px;
}

.men_informain {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  padding: changeRem(.6)+px;
  margin-top: changeRem(.4)+px;
  h1 {
    font-size: changeRem(.68)+px;
    color: #333;
    padding-bottom: changeRem(.4)+px;
    border-bottom: 2px solid #ccc;
    text-align: left;
  }
  h2 {
    width: 100%;
    text-align: left;
    vertical-align: middle;
    span {
      margin-top: changeRem(.4)+px;
      display: inline-block;
      width: auto;
      padding: 0 changeRem(.4)+px;
      height: changeRem(1)+px;
      line-height: changeRem(1)+px;
      background: rgba(240, 240, 240, 1);
      border-radius: 2px;
      margin-right: changeRem(.4)+px;
      font-size: changeRem(.56)+px;
      color: #333;
    }
  }
  p {
    font-size: changeRem(.52)+px;
    color: #333;
    line-height: changeRem(.8)+px;
    text-align: justify;
    margin-top: changeRem(.4)+px;
    word-wrap: break-word;
  }
  .pj_p {
    color: #666;
  }
  .men_pj {
    width: 100%;
    padding-bottom: changeRem(.6)+px;
    border-bottom: 2px solid #ccc;
  }
  .informain_top {
    width: 100%;
    padding-top: changeRem(.6)+px;
    img {
      width: changeRem(1.2)+px;
      height: changeRem(1.2)+px;
      border-radius: 50%;
      float: left;
    }
    .infor_r {
      width: changeRem(12)+px;
      float: right;
      text-align: left;
      padding-top: changeRem(.1)+px;
      h3 {
        font-size: changeRem(.52)+px;
        color: #333;
        span {
          font-size: changeRem(.52)+px;
          color: #F57F17;
          margin-left: changeRem(.5)+px;
          vertical-align: middle;
        }
        .spr {
          margin-left: 0
        }
        i {
          width: 2px;
          height: changeRem(.5)+px;
          vertical-align: middle;
          display: inline-block;
          margin: 0 changeRem(.4)+px;
        }
      }
      h4 {
        font-size: changeRem(.4)+px;
        color: #999;
        margin-top: changeRem(.2)+px;
      }
    }
  }
}

.close_pj {
  margin: 0 auto;
  margin-top: changeRem(.4)+px;
  width: changeRem(.88)+px;
  height: changeRem(.6)+px;
  background: url(../../../assets/down_l.png) no-repeat top center;
  background-size: cover;
}
</style>
